import {TaskManager} from "./System/TaskManager";
import {ServiceManager} from "./System/ServiceManager";

export const taskManager = new TaskManager();
export const serviceManager = new ServiceManager();